export const roundNumber = (value, decimals = 0) => {
    return parseFloat(value.toFixed(decimals));
};
